module.exports = __webpack_public_path__ + "assets/new-10db9f.svg";